export default function TopBar() {
  return (
    <header className="flex h-14 items-center bg-white px-6 shadow-sm">
      <h1 className="text-lg font-semibold text-slate-900">
        FreeAgent Reporting Dashboard
      </h1>
    </header>
  );
}
